import React from 'react';

import { CONFIGURATOR_STEPS } from '../constants';
import { ConfiguratorContextStep, ConfiguratorStep, ConfiguratorStepClickHandler } from '../types';
import { getInitialStep } from '../utils/state';

export function useSteps() {
  const [step, setStep] = React.useState<ConfiguratorStep>(getInitialStep());

  const handleStepClick = React.useCallback<ConfiguratorStepClickHandler>((nextStep) => {
    setStep(nextStep);
  }, []);

  const steps = React.useMemo<ConfiguratorContextStep[]>(() => {
    return CONFIGURATOR_STEPS.map((configuratorStep) => ({
      ...configuratorStep,
      active: configuratorStep.id === step.id,
      onClick: () => handleStepClick(configuratorStep),
    }));
  }, [step, handleStepClick]);

  return React.useMemo(() => ({ step, steps }), [step, steps]);
}
